// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// TODO: Ideally It would be better to have this kind of code with the blueprint itself
// Right now it can be done with the rawHtml but it trick...
function setupNavigationListeners() {
  $(document).on('click', '.elNavigatorButton', function () {
    $(this).parent().find('.elNavigatorModal').show()
  })

  $(document).on('click', '.elNavigatorClose', function () {
    $(this).parent().closest('.elNavigatorModal').hide()
  })

  $(document).on('click', '.elTypographyLink', function () {
    $(this).parent().closest('.elNavigatorModal').hide()
  })
}

window.addEventListener('load', setupNavigationListeners)
